/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MfaRouteImport } from './routes/mfa'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppProcessMapRouteImport } from './routes/_app/process-map'
import { Route as AppModulePageRouteImport } from './routes/_app/$module.$page'
import { Route as AppEngineeringBomStructureRouteImport } from './routes/_app/engineering/bom-structure'
import { Route as AppEngineeringBomsRouteImport } from './routes/_app/engineering/boms'
import { Route as AppEngineeringChangesRouteImport } from './routes/_app/engineering/changes'
import { Route as AppEngineeringEngineeringBomsRouteImport } from './routes/_app/engineering/engineering-boms'
import { Route as AppEngineeringProductionBomsRouteImport } from './routes/_app/engineering/production-boms'
import { Route as AppManufacturingBomStructureRouteImport } from './routes/_app/manufacturing/bom-structure'
import { Route as AppManufacturingBomsRouteImport } from './routes/_app/manufacturing/boms'
import { Route as AppManufacturingDashboardRouteImport } from './routes/_app/manufacturing/dashboard'
import { Route as AppManufacturingEngineeringBomsRouteImport } from './routes/_app/manufacturing/engineering-boms'
import { Route as AppManufacturingKitsRouteImport } from './routes/_app/manufacturing/kits'
import { Route as AppManufacturingProductionOrdersRouteImport } from './routes/_app/manufacturing/production-orders'
import { Route as AppManufacturingRoutingsRouteImport } from './routes/_app/manufacturing/routings'
import { Route as AppManufacturingWorkCentersRouteImport } from './routes/_app/manufacturing/work-centers'
import { Route as AppManufacturingWorkbenchRouteImport } from './routes/_app/manufacturing/workbench'
import { Route as AppMasterDataAdjustmentReasonsRouteImport } from './routes/_app/master-data/adjustment-reasons'
import { Route as AppMasterDataBomsRouteImport } from './routes/_app/master-data/boms'
import { Route as AppMasterDataCharacteristicsRouteImport } from './routes/_app/master-data/characteristics'
import { Route as AppMasterDataEngineeringBomsRouteImport } from './routes/_app/master-data/engineering-boms'
import { Route as AppMasterDataInspectionPlansRouteImport } from './routes/_app/master-data/inspection-plans'
import { Route as AppMasterDataItemsRouteImport } from './routes/_app/master-data/items'
import { Route as AppMasterDataLocationsRouteImport } from './routes/_app/master-data/locations'
import { Route as AppMasterDataLotsRouteImport } from './routes/_app/master-data/lots'
import { Route as AppMasterDataPartnersRouteImport } from './routes/_app/master-data/partners'
import { Route as AppMasterDataProductionBomsRouteImport } from './routes/_app/master-data/production-boms'
import { Route as AppMasterDataRoutingsRouteImport } from './routes/_app/master-data/routings'
import { Route as AppMasterDataSerialsRouteImport } from './routes/_app/master-data/serials'
import { Route as AppMasterDataUnitsRouteImport } from './routes/_app/master-data/units'
import { Route as AppMasterDataWarehousesRouteImport } from './routes/_app/master-data/warehouses'
import { Route as AppMasterDataWorkCentersRouteImport } from './routes/_app/master-data/work-centers'
import { Route as AppPlanningDashboardRouteImport } from './routes/_app/planning/dashboard'
import { Route as AppPlanningMasterPlanRouteImport } from './routes/_app/planning/master-plan'
import { Route as AppPlanningMrpRouteImport } from './routes/_app/planning/mrp'
import { Route as AppPlanningPlannedOrdersRouteImport } from './routes/_app/planning/planned-orders'
import { Route as AppPlanningStockCoverageRouteImport } from './routes/_app/planning/stock-coverage'
import { Route as AppPlanningSuggestionsRouteImport } from './routes/_app/planning/suggestions'
import { Route as AppProcurementDashboardRouteImport } from './routes/_app/procurement/dashboard'
import { Route as AppProcurementPurchaseOrdersRouteImport } from './routes/_app/procurement/purchase-orders'
import { Route as AppProcurementPurchasePriceListsRouteImport } from './routes/_app/procurement/purchase-price-lists'
import { Route as AppProcurementReceiptsRouteImport } from './routes/_app/procurement/receipts'
import { Route as AppProcurementReceivingRouteImport } from './routes/_app/procurement/receiving'
import { Route as AppProcurementSupplierReturnsRouteImport } from './routes/_app/procurement/supplier-returns'
import { Route as AppProcurementSuppliersRouteImport } from './routes/_app/procurement/suppliers'
import { Route as AppProjectDashboardRouteImport } from './routes/_app/project/dashboard'
import { Route as AppProjectMyTimeRouteImport } from './routes/_app/project/my-time'
import { Route as AppProjectProgressRouteImport } from './routes/_app/project/progress'
import { Route as AppProjectProjectsRouteImport } from './routes/_app/project/projects'
import { Route as AppQualityCharacteristicsRouteImport } from './routes/_app/quality/characteristics'
import { Route as AppQualityDashboardRouteImport } from './routes/_app/quality/dashboard'
import { Route as AppQualityInspectionOrdersRouteImport } from './routes/_app/quality/inspection-orders'
import { Route as AppQualityInspectionPlansRouteImport } from './routes/_app/quality/inspection-plans'
import { Route as AppQualityNonconformancesRouteImport } from './routes/_app/quality/nonconformances'
import { Route as AppSSessionRouteImport } from './routes/_app/s.$session'
import { Route as AppSalesCustomersRouteImport } from './routes/_app/sales/customers'
import { Route as AppSalesDashboardRouteImport } from './routes/_app/sales/dashboard'
import { Route as AppSalesDiscountsRouteImport } from './routes/_app/sales/discounts'
import { Route as AppSalesOrdersRouteImport } from './routes/_app/sales/orders'
import { Route as AppSalesPickingRouteImport } from './routes/_app/sales/picking'
import { Route as AppSalesPriceListsRouteImport } from './routes/_app/sales/price-lists'
import { Route as AppSalesReturnsRouteImport } from './routes/_app/sales/returns'
import { Route as AppSalesShipmentsRouteImport } from './routes/_app/sales/shipments'
import { Route as AppSettingsAgentsRouteImport } from './routes/_app/settings/agents'
import { Route as AppSettingsAuditLogRouteImport } from './routes/_app/settings/audit-log'
import { Route as AppSettingsCompaniesRouteImport } from './routes/_app/settings/companies'
import { Route as AppSettingsNumberingRouteImport } from './routes/_app/settings/numbering'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppWarehousingAdjustmentReasonsRouteImport } from './routes/_app/warehousing/adjustment-reasons'
import { Route as AppWarehousingAdjustmentsRouteImport } from './routes/_app/warehousing/adjustments'
import { Route as AppWarehousingCycleCountsRouteImport } from './routes/_app/warehousing/cycle-counts'
import { Route as AppWarehousingDashboardRouteImport } from './routes/_app/warehousing/dashboard'
import { Route as AppWarehousingInventoryRouteImport } from './routes/_app/warehousing/inventory'
import { Route as AppWarehousingLocationsRouteImport } from './routes/_app/warehousing/locations'
import { Route as AppWarehousingTransfersRouteImport } from './routes/_app/warehousing/transfers'
import { Route as AppWarehousingWarehouseOrdersRouteImport } from './routes/_app/warehousing/warehouse-orders'
import { Route as AppWarehousingWarehousesRouteImport } from './routes/_app/warehousing/warehouses'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaRoute = MfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppProcessMapRoute = AppProcessMapRouteImport.update({
  id: '/process-map',
  path: '/process-map',
  getParentRoute: () => AppRoute,
} as any)
const AppModulePageRoute = AppModulePageRouteImport.update({
  id: '/$module/$page',
  path: '/$module/$page',
  getParentRoute: () => AppRoute,
} as any)
const AppEngineeringBomStructureRoute =
  AppEngineeringBomStructureRouteImport.update({
    id: '/engineering/bom-structure',
    path: '/engineering/bom-structure',
    getParentRoute: () => AppRoute,
  } as any)
const AppEngineeringBomsRoute = AppEngineeringBomsRouteImport.update({
  id: '/engineering/boms',
  path: '/engineering/boms',
  getParentRoute: () => AppRoute,
} as any)
const AppEngineeringChangesRoute = AppEngineeringChangesRouteImport.update({
  id: '/engineering/changes',
  path: '/engineering/changes',
  getParentRoute: () => AppRoute,
} as any)
const AppEngineeringEngineeringBomsRoute =
  AppEngineeringEngineeringBomsRouteImport.update({
    id: '/engineering/engineering-boms',
    path: '/engineering/engineering-boms',
    getParentRoute: () => AppRoute,
  } as any)
const AppEngineeringProductionBomsRoute =
  AppEngineeringProductionBomsRouteImport.update({
    id: '/engineering/production-boms',
    path: '/engineering/production-boms',
    getParentRoute: () => AppRoute,
  } as any)
const AppManufacturingBomStructureRoute =
  AppManufacturingBomStructureRouteImport.update({
    id: '/manufacturing/bom-structure',
    path: '/manufacturing/bom-structure',
    getParentRoute: () => AppRoute,
  } as any)
const AppManufacturingBomsRoute = AppManufacturingBomsRouteImport.update({
  id: '/manufacturing/boms',
  path: '/manufacturing/boms',
  getParentRoute: () => AppRoute,
} as any)
const AppManufacturingDashboardRoute =
  AppManufacturingDashboardRouteImport.update({
    id: '/manufacturing/dashboard',
    path: '/manufacturing/dashboard',
    getParentRoute: () => AppRoute,
  } as any)
const AppManufacturingEngineeringBomsRoute =
  AppManufacturingEngineeringBomsRouteImport.update({
    id: '/manufacturing/engineering-boms',
    path: '/manufacturing/engineering-boms',
    getParentRoute: () => AppRoute,
  } as any)
const AppManufacturingKitsRoute = AppManufacturingKitsRouteImport.update({
  id: '/manufacturing/kits',
  path: '/manufacturing/kits',
  getParentRoute: () => AppRoute,
} as any)
const AppManufacturingProductionOrdersRoute =
  AppManufacturingProductionOrdersRouteImport.update({
    id: '/manufacturing/production-orders',
    path: '/manufacturing/production-orders',
    getParentRoute: () => AppRoute,
  } as any)
const AppManufacturingRoutingsRoute =
  AppManufacturingRoutingsRouteImport.update({
    id: '/manufacturing/routings',
    path: '/manufacturing/routings',
    getParentRoute: () => AppRoute,
  } as any)
const AppManufacturingWorkCentersRoute =
  AppManufacturingWorkCentersRouteImport.update({
    id: '/manufacturing/work-centers',
    path: '/manufacturing/work-centers',
    getParentRoute: () => AppRoute,
  } as any)
const AppManufacturingWorkbenchRoute =
  AppManufacturingWorkbenchRouteImport.update({
    id: '/manufacturing/workbench',
    path: '/manufacturing/workbench',
    getParentRoute: () => AppRoute,
  } as any)
const AppMasterDataAdjustmentReasonsRoute =
  AppMasterDataAdjustmentReasonsRouteImport.update({
    id: '/master-data/adjustment-reasons',
    path: '/master-data/adjustment-reasons',
    getParentRoute: () => AppRoute,
  } as any)
const AppMasterDataBomsRoute = AppMasterDataBomsRouteImport.update({
  id: '/master-data/boms',
  path: '/master-data/boms',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataCharacteristicsRoute =
  AppMasterDataCharacteristicsRouteImport.update({
    id: '/master-data/characteristics',
    path: '/master-data/characteristics',
    getParentRoute: () => AppRoute,
  } as any)
const AppMasterDataEngineeringBomsRoute =
  AppMasterDataEngineeringBomsRouteImport.update({
    id: '/master-data/engineering-boms',
    path: '/master-data/engineering-boms',
    getParentRoute: () => AppRoute,
  } as any)
const AppMasterDataInspectionPlansRoute =
  AppMasterDataInspectionPlansRouteImport.update({
    id: '/master-data/inspection-plans',
    path: '/master-data/inspection-plans',
    getParentRoute: () => AppRoute,
  } as any)
const AppMasterDataItemsRoute = AppMasterDataItemsRouteImport.update({
  id: '/master-data/items',
  path: '/master-data/items',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataLocationsRoute = AppMasterDataLocationsRouteImport.update({
  id: '/master-data/locations',
  path: '/master-data/locations',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataLotsRoute = AppMasterDataLotsRouteImport.update({
  id: '/master-data/lots',
  path: '/master-data/lots',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataPartnersRoute = AppMasterDataPartnersRouteImport.update({
  id: '/master-data/partners',
  path: '/master-data/partners',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataProductionBomsRoute =
  AppMasterDataProductionBomsRouteImport.update({
    id: '/master-data/production-boms',
    path: '/master-data/production-boms',
    getParentRoute: () => AppRoute,
  } as any)
const AppMasterDataRoutingsRoute = AppMasterDataRoutingsRouteImport.update({
  id: '/master-data/routings',
  path: '/master-data/routings',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataSerialsRoute = AppMasterDataSerialsRouteImport.update({
  id: '/master-data/serials',
  path: '/master-data/serials',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataUnitsRoute = AppMasterDataUnitsRouteImport.update({
  id: '/master-data/units',
  path: '/master-data/units',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataWarehousesRoute = AppMasterDataWarehousesRouteImport.update({
  id: '/master-data/warehouses',
  path: '/master-data/warehouses',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterDataWorkCentersRoute =
  AppMasterDataWorkCentersRouteImport.update({
    id: '/master-data/work-centers',
    path: '/master-data/work-centers',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlanningDashboardRoute = AppPlanningDashboardRouteImport.update({
  id: '/planning/dashboard',
  path: '/planning/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanningMasterPlanRoute = AppPlanningMasterPlanRouteImport.update({
  id: '/planning/master-plan',
  path: '/planning/master-plan',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanningMrpRoute = AppPlanningMrpRouteImport.update({
  id: '/planning/mrp',
  path: '/planning/mrp',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanningPlannedOrdersRoute =
  AppPlanningPlannedOrdersRouteImport.update({
    id: '/planning/planned-orders',
    path: '/planning/planned-orders',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlanningStockCoverageRoute =
  AppPlanningStockCoverageRouteImport.update({
    id: '/planning/stock-coverage',
    path: '/planning/stock-coverage',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlanningSuggestionsRoute = AppPlanningSuggestionsRouteImport.update({
  id: '/planning/suggestions',
  path: '/planning/suggestions',
  getParentRoute: () => AppRoute,
} as any)
const AppProcurementDashboardRoute = AppProcurementDashboardRouteImport.update({
  id: '/procurement/dashboard',
  path: '/procurement/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppProcurementPurchaseOrdersRoute =
  AppProcurementPurchaseOrdersRouteImport.update({
    id: '/procurement/purchase-orders',
    path: '/procurement/purchase-orders',
    getParentRoute: () => AppRoute,
  } as any)
const AppProcurementPurchasePriceListsRoute =
  AppProcurementPurchasePriceListsRouteImport.update({
    id: '/procurement/purchase-price-lists',
    path: '/procurement/purchase-price-lists',
    getParentRoute: () => AppRoute,
  } as any)
const AppProcurementReceiptsRoute = AppProcurementReceiptsRouteImport.update({
  id: '/procurement/receipts',
  path: '/procurement/receipts',
  getParentRoute: () => AppRoute,
} as any)
const AppProcurementReceivingRoute = AppProcurementReceivingRouteImport.update({
  id: '/procurement/receiving',
  path: '/procurement/receiving',
  getParentRoute: () => AppRoute,
} as any)
const AppProcurementSupplierReturnsRoute =
  AppProcurementSupplierReturnsRouteImport.update({
    id: '/procurement/supplier-returns',
    path: '/procurement/supplier-returns',
    getParentRoute: () => AppRoute,
  } as any)
const AppProcurementSuppliersRoute = AppProcurementSuppliersRouteImport.update({
  id: '/procurement/suppliers',
  path: '/procurement/suppliers',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectDashboardRoute = AppProjectDashboardRouteImport.update({
  id: '/project/dashboard',
  path: '/project/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectMyTimeRoute = AppProjectMyTimeRouteImport.update({
  id: '/project/my-time',
  path: '/project/my-time',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectProgressRoute = AppProjectProgressRouteImport.update({
  id: '/project/progress',
  path: '/project/progress',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectProjectsRoute = AppProjectProjectsRouteImport.update({
  id: '/project/projects',
  path: '/project/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppQualityCharacteristicsRoute =
  AppQualityCharacteristicsRouteImport.update({
    id: '/quality/characteristics',
    path: '/quality/characteristics',
    getParentRoute: () => AppRoute,
  } as any)
const AppQualityDashboardRoute = AppQualityDashboardRouteImport.update({
  id: '/quality/dashboard',
  path: '/quality/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppQualityInspectionOrdersRoute =
  AppQualityInspectionOrdersRouteImport.update({
    id: '/quality/inspection-orders',
    path: '/quality/inspection-orders',
    getParentRoute: () => AppRoute,
  } as any)
const AppQualityInspectionPlansRoute =
  AppQualityInspectionPlansRouteImport.update({
    id: '/quality/inspection-plans',
    path: '/quality/inspection-plans',
    getParentRoute: () => AppRoute,
  } as any)
const AppQualityNonconformancesRoute =
  AppQualityNonconformancesRouteImport.update({
    id: '/quality/nonconformances',
    path: '/quality/nonconformances',
    getParentRoute: () => AppRoute,
  } as any)
const AppSSessionRoute = AppSSessionRouteImport.update({
  id: '/s/$session',
  path: '/s/$session',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesCustomersRoute = AppSalesCustomersRouteImport.update({
  id: '/sales/customers',
  path: '/sales/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDashboardRoute = AppSalesDashboardRouteImport.update({
  id: '/sales/dashboard',
  path: '/sales/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDiscountsRoute = AppSalesDiscountsRouteImport.update({
  id: '/sales/discounts',
  path: '/sales/discounts',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesOrdersRoute = AppSalesOrdersRouteImport.update({
  id: '/sales/orders',
  path: '/sales/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesPickingRoute = AppSalesPickingRouteImport.update({
  id: '/sales/picking',
  path: '/sales/picking',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesPriceListsRoute = AppSalesPriceListsRouteImport.update({
  id: '/sales/price-lists',
  path: '/sales/price-lists',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesReturnsRoute = AppSalesReturnsRouteImport.update({
  id: '/sales/returns',
  path: '/sales/returns',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesShipmentsRoute = AppSalesShipmentsRouteImport.update({
  id: '/sales/shipments',
  path: '/sales/shipments',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAgentsRoute = AppSettingsAgentsRouteImport.update({
  id: '/settings/agents',
  path: '/settings/agents',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAuditLogRoute = AppSettingsAuditLogRouteImport.update({
  id: '/settings/audit-log',
  path: '/settings/audit-log',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCompaniesRoute = AppSettingsCompaniesRouteImport.update({
  id: '/settings/companies',
  path: '/settings/companies',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsNumberingRoute = AppSettingsNumberingRouteImport.update({
  id: '/settings/numbering',
  path: '/settings/numbering',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppWarehousingAdjustmentReasonsRoute =
  AppWarehousingAdjustmentReasonsRouteImport.update({
    id: '/warehousing/adjustment-reasons',
    path: '/warehousing/adjustment-reasons',
    getParentRoute: () => AppRoute,
  } as any)
const AppWarehousingAdjustmentsRoute =
  AppWarehousingAdjustmentsRouteImport.update({
    id: '/warehousing/adjustments',
    path: '/warehousing/adjustments',
    getParentRoute: () => AppRoute,
  } as any)
const AppWarehousingCycleCountsRoute =
  AppWarehousingCycleCountsRouteImport.update({
    id: '/warehousing/cycle-counts',
    path: '/warehousing/cycle-counts',
    getParentRoute: () => AppRoute,
  } as any)
const AppWarehousingDashboardRoute = AppWarehousingDashboardRouteImport.update({
  id: '/warehousing/dashboard',
  path: '/warehousing/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppWarehousingInventoryRoute = AppWarehousingInventoryRouteImport.update({
  id: '/warehousing/inventory',
  path: '/warehousing/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppWarehousingLocationsRoute = AppWarehousingLocationsRouteImport.update({
  id: '/warehousing/locations',
  path: '/warehousing/locations',
  getParentRoute: () => AppRoute,
} as any)
const AppWarehousingTransfersRoute = AppWarehousingTransfersRouteImport.update({
  id: '/warehousing/transfers',
  path: '/warehousing/transfers',
  getParentRoute: () => AppRoute,
} as any)
const AppWarehousingWarehouseOrdersRoute =
  AppWarehousingWarehouseOrdersRouteImport.update({
    id: '/warehousing/warehouse-orders',
    path: '/warehousing/warehouse-orders',
    getParentRoute: () => AppRoute,
  } as any)
const AppWarehousingWarehousesRoute =
  AppWarehousingWarehousesRouteImport.update({
    id: '/warehousing/warehouses',
    path: '/warehousing/warehouses',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/onboarding': typeof OnboardingRoute
  '/process-map': typeof AppProcessMapRoute
  '/$module/$page': typeof AppModulePageRoute
  '/engineering/bom-structure': typeof AppEngineeringBomStructureRoute
  '/engineering/boms': typeof AppEngineeringBomsRoute
  '/engineering/changes': typeof AppEngineeringChangesRoute
  '/engineering/engineering-boms': typeof AppEngineeringEngineeringBomsRoute
  '/engineering/production-boms': typeof AppEngineeringProductionBomsRoute
  '/manufacturing/bom-structure': typeof AppManufacturingBomStructureRoute
  '/manufacturing/boms': typeof AppManufacturingBomsRoute
  '/manufacturing/dashboard': typeof AppManufacturingDashboardRoute
  '/manufacturing/engineering-boms': typeof AppManufacturingEngineeringBomsRoute
  '/manufacturing/kits': typeof AppManufacturingKitsRoute
  '/manufacturing/production-orders': typeof AppManufacturingProductionOrdersRoute
  '/manufacturing/routings': typeof AppManufacturingRoutingsRoute
  '/manufacturing/work-centers': typeof AppManufacturingWorkCentersRoute
  '/manufacturing/workbench': typeof AppManufacturingWorkbenchRoute
  '/master-data/adjustment-reasons': typeof AppMasterDataAdjustmentReasonsRoute
  '/master-data/boms': typeof AppMasterDataBomsRoute
  '/master-data/characteristics': typeof AppMasterDataCharacteristicsRoute
  '/master-data/engineering-boms': typeof AppMasterDataEngineeringBomsRoute
  '/master-data/inspection-plans': typeof AppMasterDataInspectionPlansRoute
  '/master-data/items': typeof AppMasterDataItemsRoute
  '/master-data/locations': typeof AppMasterDataLocationsRoute
  '/master-data/lots': typeof AppMasterDataLotsRoute
  '/master-data/partners': typeof AppMasterDataPartnersRoute
  '/master-data/production-boms': typeof AppMasterDataProductionBomsRoute
  '/master-data/routings': typeof AppMasterDataRoutingsRoute
  '/master-data/serials': typeof AppMasterDataSerialsRoute
  '/master-data/units': typeof AppMasterDataUnitsRoute
  '/master-data/warehouses': typeof AppMasterDataWarehousesRoute
  '/master-data/work-centers': typeof AppMasterDataWorkCentersRoute
  '/planning/dashboard': typeof AppPlanningDashboardRoute
  '/planning/master-plan': typeof AppPlanningMasterPlanRoute
  '/planning/mrp': typeof AppPlanningMrpRoute
  '/planning/planned-orders': typeof AppPlanningPlannedOrdersRoute
  '/planning/stock-coverage': typeof AppPlanningStockCoverageRoute
  '/planning/suggestions': typeof AppPlanningSuggestionsRoute
  '/procurement/dashboard': typeof AppProcurementDashboardRoute
  '/procurement/purchase-orders': typeof AppProcurementPurchaseOrdersRoute
  '/procurement/purchase-price-lists': typeof AppProcurementPurchasePriceListsRoute
  '/procurement/receipts': typeof AppProcurementReceiptsRoute
  '/procurement/receiving': typeof AppProcurementReceivingRoute
  '/procurement/supplier-returns': typeof AppProcurementSupplierReturnsRoute
  '/procurement/suppliers': typeof AppProcurementSuppliersRoute
  '/project/dashboard': typeof AppProjectDashboardRoute
  '/project/my-time': typeof AppProjectMyTimeRoute
  '/project/progress': typeof AppProjectProgressRoute
  '/project/projects': typeof AppProjectProjectsRoute
  '/quality/characteristics': typeof AppQualityCharacteristicsRoute
  '/quality/dashboard': typeof AppQualityDashboardRoute
  '/quality/inspection-orders': typeof AppQualityInspectionOrdersRoute
  '/quality/inspection-plans': typeof AppQualityInspectionPlansRoute
  '/quality/nonconformances': typeof AppQualityNonconformancesRoute
  '/s/$session': typeof AppSSessionRoute
  '/sales/customers': typeof AppSalesCustomersRoute
  '/sales/dashboard': typeof AppSalesDashboardRoute
  '/sales/discounts': typeof AppSalesDiscountsRoute
  '/sales/orders': typeof AppSalesOrdersRoute
  '/sales/picking': typeof AppSalesPickingRoute
  '/sales/price-lists': typeof AppSalesPriceListsRoute
  '/sales/returns': typeof AppSalesReturnsRoute
  '/sales/shipments': typeof AppSalesShipmentsRoute
  '/settings/agents': typeof AppSettingsAgentsRoute
  '/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/settings/companies': typeof AppSettingsCompaniesRoute
  '/settings/numbering': typeof AppSettingsNumberingRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/warehousing/adjustment-reasons': typeof AppWarehousingAdjustmentReasonsRoute
  '/warehousing/adjustments': typeof AppWarehousingAdjustmentsRoute
  '/warehousing/cycle-counts': typeof AppWarehousingCycleCountsRoute
  '/warehousing/dashboard': typeof AppWarehousingDashboardRoute
  '/warehousing/inventory': typeof AppWarehousingInventoryRoute
  '/warehousing/locations': typeof AppWarehousingLocationsRoute
  '/warehousing/transfers': typeof AppWarehousingTransfersRoute
  '/warehousing/warehouse-orders': typeof AppWarehousingWarehouseOrdersRoute
  '/warehousing/warehouses': typeof AppWarehousingWarehousesRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/onboarding': typeof OnboardingRoute
  '/process-map': typeof AppProcessMapRoute
  '/': typeof AppIndexRoute
  '/$module/$page': typeof AppModulePageRoute
  '/engineering/bom-structure': typeof AppEngineeringBomStructureRoute
  '/engineering/boms': typeof AppEngineeringBomsRoute
  '/engineering/changes': typeof AppEngineeringChangesRoute
  '/engineering/engineering-boms': typeof AppEngineeringEngineeringBomsRoute
  '/engineering/production-boms': typeof AppEngineeringProductionBomsRoute
  '/manufacturing/bom-structure': typeof AppManufacturingBomStructureRoute
  '/manufacturing/boms': typeof AppManufacturingBomsRoute
  '/manufacturing/dashboard': typeof AppManufacturingDashboardRoute
  '/manufacturing/engineering-boms': typeof AppManufacturingEngineeringBomsRoute
  '/manufacturing/kits': typeof AppManufacturingKitsRoute
  '/manufacturing/production-orders': typeof AppManufacturingProductionOrdersRoute
  '/manufacturing/routings': typeof AppManufacturingRoutingsRoute
  '/manufacturing/work-centers': typeof AppManufacturingWorkCentersRoute
  '/manufacturing/workbench': typeof AppManufacturingWorkbenchRoute
  '/master-data/adjustment-reasons': typeof AppMasterDataAdjustmentReasonsRoute
  '/master-data/boms': typeof AppMasterDataBomsRoute
  '/master-data/characteristics': typeof AppMasterDataCharacteristicsRoute
  '/master-data/engineering-boms': typeof AppMasterDataEngineeringBomsRoute
  '/master-data/inspection-plans': typeof AppMasterDataInspectionPlansRoute
  '/master-data/items': typeof AppMasterDataItemsRoute
  '/master-data/locations': typeof AppMasterDataLocationsRoute
  '/master-data/lots': typeof AppMasterDataLotsRoute
  '/master-data/partners': typeof AppMasterDataPartnersRoute
  '/master-data/production-boms': typeof AppMasterDataProductionBomsRoute
  '/master-data/routings': typeof AppMasterDataRoutingsRoute
  '/master-data/serials': typeof AppMasterDataSerialsRoute
  '/master-data/units': typeof AppMasterDataUnitsRoute
  '/master-data/warehouses': typeof AppMasterDataWarehousesRoute
  '/master-data/work-centers': typeof AppMasterDataWorkCentersRoute
  '/planning/dashboard': typeof AppPlanningDashboardRoute
  '/planning/master-plan': typeof AppPlanningMasterPlanRoute
  '/planning/mrp': typeof AppPlanningMrpRoute
  '/planning/planned-orders': typeof AppPlanningPlannedOrdersRoute
  '/planning/stock-coverage': typeof AppPlanningStockCoverageRoute
  '/planning/suggestions': typeof AppPlanningSuggestionsRoute
  '/procurement/dashboard': typeof AppProcurementDashboardRoute
  '/procurement/purchase-orders': typeof AppProcurementPurchaseOrdersRoute
  '/procurement/purchase-price-lists': typeof AppProcurementPurchasePriceListsRoute
  '/procurement/receipts': typeof AppProcurementReceiptsRoute
  '/procurement/receiving': typeof AppProcurementReceivingRoute
  '/procurement/supplier-returns': typeof AppProcurementSupplierReturnsRoute
  '/procurement/suppliers': typeof AppProcurementSuppliersRoute
  '/project/dashboard': typeof AppProjectDashboardRoute
  '/project/my-time': typeof AppProjectMyTimeRoute
  '/project/progress': typeof AppProjectProgressRoute
  '/project/projects': typeof AppProjectProjectsRoute
  '/quality/characteristics': typeof AppQualityCharacteristicsRoute
  '/quality/dashboard': typeof AppQualityDashboardRoute
  '/quality/inspection-orders': typeof AppQualityInspectionOrdersRoute
  '/quality/inspection-plans': typeof AppQualityInspectionPlansRoute
  '/quality/nonconformances': typeof AppQualityNonconformancesRoute
  '/s/$session': typeof AppSSessionRoute
  '/sales/customers': typeof AppSalesCustomersRoute
  '/sales/dashboard': typeof AppSalesDashboardRoute
  '/sales/discounts': typeof AppSalesDiscountsRoute
  '/sales/orders': typeof AppSalesOrdersRoute
  '/sales/picking': typeof AppSalesPickingRoute
  '/sales/price-lists': typeof AppSalesPriceListsRoute
  '/sales/returns': typeof AppSalesReturnsRoute
  '/sales/shipments': typeof AppSalesShipmentsRoute
  '/settings/agents': typeof AppSettingsAgentsRoute
  '/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/settings/companies': typeof AppSettingsCompaniesRoute
  '/settings/numbering': typeof AppSettingsNumberingRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/warehousing/adjustment-reasons': typeof AppWarehousingAdjustmentReasonsRoute
  '/warehousing/adjustments': typeof AppWarehousingAdjustmentsRoute
  '/warehousing/cycle-counts': typeof AppWarehousingCycleCountsRoute
  '/warehousing/dashboard': typeof AppWarehousingDashboardRoute
  '/warehousing/inventory': typeof AppWarehousingInventoryRoute
  '/warehousing/locations': typeof AppWarehousingLocationsRoute
  '/warehousing/transfers': typeof AppWarehousingTransfersRoute
  '/warehousing/warehouse-orders': typeof AppWarehousingWarehouseOrdersRoute
  '/warehousing/warehouses': typeof AppWarehousingWarehousesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/onboarding': typeof OnboardingRoute
  '/_app/process-map': typeof AppProcessMapRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$module/$page': typeof AppModulePageRoute
  '/_app/engineering/bom-structure': typeof AppEngineeringBomStructureRoute
  '/_app/engineering/boms': typeof AppEngineeringBomsRoute
  '/_app/engineering/changes': typeof AppEngineeringChangesRoute
  '/_app/engineering/engineering-boms': typeof AppEngineeringEngineeringBomsRoute
  '/_app/engineering/production-boms': typeof AppEngineeringProductionBomsRoute
  '/_app/manufacturing/bom-structure': typeof AppManufacturingBomStructureRoute
  '/_app/manufacturing/boms': typeof AppManufacturingBomsRoute
  '/_app/manufacturing/dashboard': typeof AppManufacturingDashboardRoute
  '/_app/manufacturing/engineering-boms': typeof AppManufacturingEngineeringBomsRoute
  '/_app/manufacturing/kits': typeof AppManufacturingKitsRoute
  '/_app/manufacturing/production-orders': typeof AppManufacturingProductionOrdersRoute
  '/_app/manufacturing/routings': typeof AppManufacturingRoutingsRoute
  '/_app/manufacturing/work-centers': typeof AppManufacturingWorkCentersRoute
  '/_app/manufacturing/workbench': typeof AppManufacturingWorkbenchRoute
  '/_app/master-data/adjustment-reasons': typeof AppMasterDataAdjustmentReasonsRoute
  '/_app/master-data/boms': typeof AppMasterDataBomsRoute
  '/_app/master-data/characteristics': typeof AppMasterDataCharacteristicsRoute
  '/_app/master-data/engineering-boms': typeof AppMasterDataEngineeringBomsRoute
  '/_app/master-data/inspection-plans': typeof AppMasterDataInspectionPlansRoute
  '/_app/master-data/items': typeof AppMasterDataItemsRoute
  '/_app/master-data/locations': typeof AppMasterDataLocationsRoute
  '/_app/master-data/lots': typeof AppMasterDataLotsRoute
  '/_app/master-data/partners': typeof AppMasterDataPartnersRoute
  '/_app/master-data/production-boms': typeof AppMasterDataProductionBomsRoute
  '/_app/master-data/routings': typeof AppMasterDataRoutingsRoute
  '/_app/master-data/serials': typeof AppMasterDataSerialsRoute
  '/_app/master-data/units': typeof AppMasterDataUnitsRoute
  '/_app/master-data/warehouses': typeof AppMasterDataWarehousesRoute
  '/_app/master-data/work-centers': typeof AppMasterDataWorkCentersRoute
  '/_app/planning/dashboard': typeof AppPlanningDashboardRoute
  '/_app/planning/master-plan': typeof AppPlanningMasterPlanRoute
  '/_app/planning/mrp': typeof AppPlanningMrpRoute
  '/_app/planning/planned-orders': typeof AppPlanningPlannedOrdersRoute
  '/_app/planning/stock-coverage': typeof AppPlanningStockCoverageRoute
  '/_app/planning/suggestions': typeof AppPlanningSuggestionsRoute
  '/_app/procurement/dashboard': typeof AppProcurementDashboardRoute
  '/_app/procurement/purchase-orders': typeof AppProcurementPurchaseOrdersRoute
  '/_app/procurement/purchase-price-lists': typeof AppProcurementPurchasePriceListsRoute
  '/_app/procurement/receipts': typeof AppProcurementReceiptsRoute
  '/_app/procurement/receiving': typeof AppProcurementReceivingRoute
  '/_app/procurement/supplier-returns': typeof AppProcurementSupplierReturnsRoute
  '/_app/procurement/suppliers': typeof AppProcurementSuppliersRoute
  '/_app/project/dashboard': typeof AppProjectDashboardRoute
  '/_app/project/my-time': typeof AppProjectMyTimeRoute
  '/_app/project/progress': typeof AppProjectProgressRoute
  '/_app/project/projects': typeof AppProjectProjectsRoute
  '/_app/quality/characteristics': typeof AppQualityCharacteristicsRoute
  '/_app/quality/dashboard': typeof AppQualityDashboardRoute
  '/_app/quality/inspection-orders': typeof AppQualityInspectionOrdersRoute
  '/_app/quality/inspection-plans': typeof AppQualityInspectionPlansRoute
  '/_app/quality/nonconformances': typeof AppQualityNonconformancesRoute
  '/_app/s/$session': typeof AppSSessionRoute
  '/_app/sales/customers': typeof AppSalesCustomersRoute
  '/_app/sales/dashboard': typeof AppSalesDashboardRoute
  '/_app/sales/discounts': typeof AppSalesDiscountsRoute
  '/_app/sales/orders': typeof AppSalesOrdersRoute
  '/_app/sales/picking': typeof AppSalesPickingRoute
  '/_app/sales/price-lists': typeof AppSalesPriceListsRoute
  '/_app/sales/returns': typeof AppSalesReturnsRoute
  '/_app/sales/shipments': typeof AppSalesShipmentsRoute
  '/_app/settings/agents': typeof AppSettingsAgentsRoute
  '/_app/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/_app/settings/companies': typeof AppSettingsCompaniesRoute
  '/_app/settings/numbering': typeof AppSettingsNumberingRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/warehousing/adjustment-reasons': typeof AppWarehousingAdjustmentReasonsRoute
  '/_app/warehousing/adjustments': typeof AppWarehousingAdjustmentsRoute
  '/_app/warehousing/cycle-counts': typeof AppWarehousingCycleCountsRoute
  '/_app/warehousing/dashboard': typeof AppWarehousingDashboardRoute
  '/_app/warehousing/inventory': typeof AppWarehousingInventoryRoute
  '/_app/warehousing/locations': typeof AppWarehousingLocationsRoute
  '/_app/warehousing/transfers': typeof AppWarehousingTransfersRoute
  '/_app/warehousing/warehouse-orders': typeof AppWarehousingWarehouseOrdersRoute
  '/_app/warehousing/warehouses': typeof AppWarehousingWarehousesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/mfa'
    | '/onboarding'
    | '/process-map'
    | '/$module/$page'
    | '/engineering/bom-structure'
    | '/engineering/boms'
    | '/engineering/changes'
    | '/engineering/engineering-boms'
    | '/engineering/production-boms'
    | '/manufacturing/bom-structure'
    | '/manufacturing/boms'
    | '/manufacturing/dashboard'
    | '/manufacturing/engineering-boms'
    | '/manufacturing/kits'
    | '/manufacturing/production-orders'
    | '/manufacturing/routings'
    | '/manufacturing/work-centers'
    | '/manufacturing/workbench'
    | '/master-data/adjustment-reasons'
    | '/master-data/boms'
    | '/master-data/characteristics'
    | '/master-data/engineering-boms'
    | '/master-data/inspection-plans'
    | '/master-data/items'
    | '/master-data/locations'
    | '/master-data/lots'
    | '/master-data/partners'
    | '/master-data/production-boms'
    | '/master-data/routings'
    | '/master-data/serials'
    | '/master-data/units'
    | '/master-data/warehouses'
    | '/master-data/work-centers'
    | '/planning/dashboard'
    | '/planning/master-plan'
    | '/planning/mrp'
    | '/planning/planned-orders'
    | '/planning/stock-coverage'
    | '/planning/suggestions'
    | '/procurement/dashboard'
    | '/procurement/purchase-orders'
    | '/procurement/purchase-price-lists'
    | '/procurement/receipts'
    | '/procurement/receiving'
    | '/procurement/supplier-returns'
    | '/procurement/suppliers'
    | '/project/dashboard'
    | '/project/my-time'
    | '/project/progress'
    | '/project/projects'
    | '/quality/characteristics'
    | '/quality/dashboard'
    | '/quality/inspection-orders'
    | '/quality/inspection-plans'
    | '/quality/nonconformances'
    | '/s/$session'
    | '/sales/customers'
    | '/sales/dashboard'
    | '/sales/discounts'
    | '/sales/orders'
    | '/sales/picking'
    | '/sales/price-lists'
    | '/sales/returns'
    | '/sales/shipments'
    | '/settings/agents'
    | '/settings/audit-log'
    | '/settings/companies'
    | '/settings/numbering'
    | '/settings/security'
    | '/settings/users'
    | '/warehousing/adjustment-reasons'
    | '/warehousing/adjustments'
    | '/warehousing/cycle-counts'
    | '/warehousing/dashboard'
    | '/warehousing/inventory'
    | '/warehousing/locations'
    | '/warehousing/transfers'
    | '/warehousing/warehouse-orders'
    | '/warehousing/warehouses'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/mfa'
    | '/onboarding'
    | '/process-map'
    | '/'
    | '/$module/$page'
    | '/engineering/bom-structure'
    | '/engineering/boms'
    | '/engineering/changes'
    | '/engineering/engineering-boms'
    | '/engineering/production-boms'
    | '/manufacturing/bom-structure'
    | '/manufacturing/boms'
    | '/manufacturing/dashboard'
    | '/manufacturing/engineering-boms'
    | '/manufacturing/kits'
    | '/manufacturing/production-orders'
    | '/manufacturing/routings'
    | '/manufacturing/work-centers'
    | '/manufacturing/workbench'
    | '/master-data/adjustment-reasons'
    | '/master-data/boms'
    | '/master-data/characteristics'
    | '/master-data/engineering-boms'
    | '/master-data/inspection-plans'
    | '/master-data/items'
    | '/master-data/locations'
    | '/master-data/lots'
    | '/master-data/partners'
    | '/master-data/production-boms'
    | '/master-data/routings'
    | '/master-data/serials'
    | '/master-data/units'
    | '/master-data/warehouses'
    | '/master-data/work-centers'
    | '/planning/dashboard'
    | '/planning/master-plan'
    | '/planning/mrp'
    | '/planning/planned-orders'
    | '/planning/stock-coverage'
    | '/planning/suggestions'
    | '/procurement/dashboard'
    | '/procurement/purchase-orders'
    | '/procurement/purchase-price-lists'
    | '/procurement/receipts'
    | '/procurement/receiving'
    | '/procurement/supplier-returns'
    | '/procurement/suppliers'
    | '/project/dashboard'
    | '/project/my-time'
    | '/project/progress'
    | '/project/projects'
    | '/quality/characteristics'
    | '/quality/dashboard'
    | '/quality/inspection-orders'
    | '/quality/inspection-plans'
    | '/quality/nonconformances'
    | '/s/$session'
    | '/sales/customers'
    | '/sales/dashboard'
    | '/sales/discounts'
    | '/sales/orders'
    | '/sales/picking'
    | '/sales/price-lists'
    | '/sales/returns'
    | '/sales/shipments'
    | '/settings/agents'
    | '/settings/audit-log'
    | '/settings/companies'
    | '/settings/numbering'
    | '/settings/security'
    | '/settings/users'
    | '/warehousing/adjustment-reasons'
    | '/warehousing/adjustments'
    | '/warehousing/cycle-counts'
    | '/warehousing/dashboard'
    | '/warehousing/inventory'
    | '/warehousing/locations'
    | '/warehousing/transfers'
    | '/warehousing/warehouse-orders'
    | '/warehousing/warehouses'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/mfa'
    | '/onboarding'
    | '/_app/process-map'
    | '/_app/'
    | '/_app/$module/$page'
    | '/_app/engineering/bom-structure'
    | '/_app/engineering/boms'
    | '/_app/engineering/changes'
    | '/_app/engineering/engineering-boms'
    | '/_app/engineering/production-boms'
    | '/_app/manufacturing/bom-structure'
    | '/_app/manufacturing/boms'
    | '/_app/manufacturing/dashboard'
    | '/_app/manufacturing/engineering-boms'
    | '/_app/manufacturing/kits'
    | '/_app/manufacturing/production-orders'
    | '/_app/manufacturing/routings'
    | '/_app/manufacturing/work-centers'
    | '/_app/manufacturing/workbench'
    | '/_app/master-data/adjustment-reasons'
    | '/_app/master-data/boms'
    | '/_app/master-data/characteristics'
    | '/_app/master-data/engineering-boms'
    | '/_app/master-data/inspection-plans'
    | '/_app/master-data/items'
    | '/_app/master-data/locations'
    | '/_app/master-data/lots'
    | '/_app/master-data/partners'
    | '/_app/master-data/production-boms'
    | '/_app/master-data/routings'
    | '/_app/master-data/serials'
    | '/_app/master-data/units'
    | '/_app/master-data/warehouses'
    | '/_app/master-data/work-centers'
    | '/_app/planning/dashboard'
    | '/_app/planning/master-plan'
    | '/_app/planning/mrp'
    | '/_app/planning/planned-orders'
    | '/_app/planning/stock-coverage'
    | '/_app/planning/suggestions'
    | '/_app/procurement/dashboard'
    | '/_app/procurement/purchase-orders'
    | '/_app/procurement/purchase-price-lists'
    | '/_app/procurement/receipts'
    | '/_app/procurement/receiving'
    | '/_app/procurement/supplier-returns'
    | '/_app/procurement/suppliers'
    | '/_app/project/dashboard'
    | '/_app/project/my-time'
    | '/_app/project/progress'
    | '/_app/project/projects'
    | '/_app/quality/characteristics'
    | '/_app/quality/dashboard'
    | '/_app/quality/inspection-orders'
    | '/_app/quality/inspection-plans'
    | '/_app/quality/nonconformances'
    | '/_app/s/$session'
    | '/_app/sales/customers'
    | '/_app/sales/dashboard'
    | '/_app/sales/discounts'
    | '/_app/sales/orders'
    | '/_app/sales/picking'
    | '/_app/sales/price-lists'
    | '/_app/sales/returns'
    | '/_app/sales/shipments'
    | '/_app/settings/agents'
    | '/_app/settings/audit-log'
    | '/_app/settings/companies'
    | '/_app/settings/numbering'
    | '/_app/settings/security'
    | '/_app/settings/users'
    | '/_app/warehousing/adjustment-reasons'
    | '/_app/warehousing/adjustments'
    | '/_app/warehousing/cycle-counts'
    | '/_app/warehousing/dashboard'
    | '/_app/warehousing/inventory'
    | '/_app/warehousing/locations'
    | '/_app/warehousing/transfers'
    | '/_app/warehousing/warehouse-orders'
    | '/_app/warehousing/warehouses'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  MfaRoute: typeof MfaRoute
  OnboardingRoute: typeof OnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa': {
      id: '/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof MfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/process-map': {
      id: '/_app/process-map'
      path: '/process-map'
      fullPath: '/process-map'
      preLoaderRoute: typeof AppProcessMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$module/$page': {
      id: '/_app/$module/$page'
      path: '/$module/$page'
      fullPath: '/$module/$page'
      preLoaderRoute: typeof AppModulePageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engineering/bom-structure': {
      id: '/_app/engineering/bom-structure'
      path: '/engineering/bom-structure'
      fullPath: '/engineering/bom-structure'
      preLoaderRoute: typeof AppEngineeringBomStructureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engineering/boms': {
      id: '/_app/engineering/boms'
      path: '/engineering/boms'
      fullPath: '/engineering/boms'
      preLoaderRoute: typeof AppEngineeringBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engineering/changes': {
      id: '/_app/engineering/changes'
      path: '/engineering/changes'
      fullPath: '/engineering/changes'
      preLoaderRoute: typeof AppEngineeringChangesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engineering/engineering-boms': {
      id: '/_app/engineering/engineering-boms'
      path: '/engineering/engineering-boms'
      fullPath: '/engineering/engineering-boms'
      preLoaderRoute: typeof AppEngineeringEngineeringBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engineering/production-boms': {
      id: '/_app/engineering/production-boms'
      path: '/engineering/production-boms'
      fullPath: '/engineering/production-boms'
      preLoaderRoute: typeof AppEngineeringProductionBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/bom-structure': {
      id: '/_app/manufacturing/bom-structure'
      path: '/manufacturing/bom-structure'
      fullPath: '/manufacturing/bom-structure'
      preLoaderRoute: typeof AppManufacturingBomStructureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/boms': {
      id: '/_app/manufacturing/boms'
      path: '/manufacturing/boms'
      fullPath: '/manufacturing/boms'
      preLoaderRoute: typeof AppManufacturingBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/dashboard': {
      id: '/_app/manufacturing/dashboard'
      path: '/manufacturing/dashboard'
      fullPath: '/manufacturing/dashboard'
      preLoaderRoute: typeof AppManufacturingDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/engineering-boms': {
      id: '/_app/manufacturing/engineering-boms'
      path: '/manufacturing/engineering-boms'
      fullPath: '/manufacturing/engineering-boms'
      preLoaderRoute: typeof AppManufacturingEngineeringBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/kits': {
      id: '/_app/manufacturing/kits'
      path: '/manufacturing/kits'
      fullPath: '/manufacturing/kits'
      preLoaderRoute: typeof AppManufacturingKitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/production-orders': {
      id: '/_app/manufacturing/production-orders'
      path: '/manufacturing/production-orders'
      fullPath: '/manufacturing/production-orders'
      preLoaderRoute: typeof AppManufacturingProductionOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/routings': {
      id: '/_app/manufacturing/routings'
      path: '/manufacturing/routings'
      fullPath: '/manufacturing/routings'
      preLoaderRoute: typeof AppManufacturingRoutingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/work-centers': {
      id: '/_app/manufacturing/work-centers'
      path: '/manufacturing/work-centers'
      fullPath: '/manufacturing/work-centers'
      preLoaderRoute: typeof AppManufacturingWorkCentersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manufacturing/workbench': {
      id: '/_app/manufacturing/workbench'
      path: '/manufacturing/workbench'
      fullPath: '/manufacturing/workbench'
      preLoaderRoute: typeof AppManufacturingWorkbenchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/adjustment-reasons': {
      id: '/_app/master-data/adjustment-reasons'
      path: '/master-data/adjustment-reasons'
      fullPath: '/master-data/adjustment-reasons'
      preLoaderRoute: typeof AppMasterDataAdjustmentReasonsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/boms': {
      id: '/_app/master-data/boms'
      path: '/master-data/boms'
      fullPath: '/master-data/boms'
      preLoaderRoute: typeof AppMasterDataBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/characteristics': {
      id: '/_app/master-data/characteristics'
      path: '/master-data/characteristics'
      fullPath: '/master-data/characteristics'
      preLoaderRoute: typeof AppMasterDataCharacteristicsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/engineering-boms': {
      id: '/_app/master-data/engineering-boms'
      path: '/master-data/engineering-boms'
      fullPath: '/master-data/engineering-boms'
      preLoaderRoute: typeof AppMasterDataEngineeringBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/inspection-plans': {
      id: '/_app/master-data/inspection-plans'
      path: '/master-data/inspection-plans'
      fullPath: '/master-data/inspection-plans'
      preLoaderRoute: typeof AppMasterDataInspectionPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/items': {
      id: '/_app/master-data/items'
      path: '/master-data/items'
      fullPath: '/master-data/items'
      preLoaderRoute: typeof AppMasterDataItemsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/locations': {
      id: '/_app/master-data/locations'
      path: '/master-data/locations'
      fullPath: '/master-data/locations'
      preLoaderRoute: typeof AppMasterDataLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/lots': {
      id: '/_app/master-data/lots'
      path: '/master-data/lots'
      fullPath: '/master-data/lots'
      preLoaderRoute: typeof AppMasterDataLotsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/partners': {
      id: '/_app/master-data/partners'
      path: '/master-data/partners'
      fullPath: '/master-data/partners'
      preLoaderRoute: typeof AppMasterDataPartnersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/production-boms': {
      id: '/_app/master-data/production-boms'
      path: '/master-data/production-boms'
      fullPath: '/master-data/production-boms'
      preLoaderRoute: typeof AppMasterDataProductionBomsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/routings': {
      id: '/_app/master-data/routings'
      path: '/master-data/routings'
      fullPath: '/master-data/routings'
      preLoaderRoute: typeof AppMasterDataRoutingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/serials': {
      id: '/_app/master-data/serials'
      path: '/master-data/serials'
      fullPath: '/master-data/serials'
      preLoaderRoute: typeof AppMasterDataSerialsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/units': {
      id: '/_app/master-data/units'
      path: '/master-data/units'
      fullPath: '/master-data/units'
      preLoaderRoute: typeof AppMasterDataUnitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/warehouses': {
      id: '/_app/master-data/warehouses'
      path: '/master-data/warehouses'
      fullPath: '/master-data/warehouses'
      preLoaderRoute: typeof AppMasterDataWarehousesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master-data/work-centers': {
      id: '/_app/master-data/work-centers'
      path: '/master-data/work-centers'
      fullPath: '/master-data/work-centers'
      preLoaderRoute: typeof AppMasterDataWorkCentersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning/dashboard': {
      id: '/_app/planning/dashboard'
      path: '/planning/dashboard'
      fullPath: '/planning/dashboard'
      preLoaderRoute: typeof AppPlanningDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning/master-plan': {
      id: '/_app/planning/master-plan'
      path: '/planning/master-plan'
      fullPath: '/planning/master-plan'
      preLoaderRoute: typeof AppPlanningMasterPlanRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning/mrp': {
      id: '/_app/planning/mrp'
      path: '/planning/mrp'
      fullPath: '/planning/mrp'
      preLoaderRoute: typeof AppPlanningMrpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning/planned-orders': {
      id: '/_app/planning/planned-orders'
      path: '/planning/planned-orders'
      fullPath: '/planning/planned-orders'
      preLoaderRoute: typeof AppPlanningPlannedOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning/stock-coverage': {
      id: '/_app/planning/stock-coverage'
      path: '/planning/stock-coverage'
      fullPath: '/planning/stock-coverage'
      preLoaderRoute: typeof AppPlanningStockCoverageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning/suggestions': {
      id: '/_app/planning/suggestions'
      path: '/planning/suggestions'
      fullPath: '/planning/suggestions'
      preLoaderRoute: typeof AppPlanningSuggestionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/dashboard': {
      id: '/_app/procurement/dashboard'
      path: '/procurement/dashboard'
      fullPath: '/procurement/dashboard'
      preLoaderRoute: typeof AppProcurementDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/purchase-orders': {
      id: '/_app/procurement/purchase-orders'
      path: '/procurement/purchase-orders'
      fullPath: '/procurement/purchase-orders'
      preLoaderRoute: typeof AppProcurementPurchaseOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/purchase-price-lists': {
      id: '/_app/procurement/purchase-price-lists'
      path: '/procurement/purchase-price-lists'
      fullPath: '/procurement/purchase-price-lists'
      preLoaderRoute: typeof AppProcurementPurchasePriceListsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/receipts': {
      id: '/_app/procurement/receipts'
      path: '/procurement/receipts'
      fullPath: '/procurement/receipts'
      preLoaderRoute: typeof AppProcurementReceiptsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/receiving': {
      id: '/_app/procurement/receiving'
      path: '/procurement/receiving'
      fullPath: '/procurement/receiving'
      preLoaderRoute: typeof AppProcurementReceivingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/supplier-returns': {
      id: '/_app/procurement/supplier-returns'
      path: '/procurement/supplier-returns'
      fullPath: '/procurement/supplier-returns'
      preLoaderRoute: typeof AppProcurementSupplierReturnsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/suppliers': {
      id: '/_app/procurement/suppliers'
      path: '/procurement/suppliers'
      fullPath: '/procurement/suppliers'
      preLoaderRoute: typeof AppProcurementSuppliersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project/dashboard': {
      id: '/_app/project/dashboard'
      path: '/project/dashboard'
      fullPath: '/project/dashboard'
      preLoaderRoute: typeof AppProjectDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project/my-time': {
      id: '/_app/project/my-time'
      path: '/project/my-time'
      fullPath: '/project/my-time'
      preLoaderRoute: typeof AppProjectMyTimeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project/progress': {
      id: '/_app/project/progress'
      path: '/project/progress'
      fullPath: '/project/progress'
      preLoaderRoute: typeof AppProjectProgressRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project/projects': {
      id: '/_app/project/projects'
      path: '/project/projects'
      fullPath: '/project/projects'
      preLoaderRoute: typeof AppProjectProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality/characteristics': {
      id: '/_app/quality/characteristics'
      path: '/quality/characteristics'
      fullPath: '/quality/characteristics'
      preLoaderRoute: typeof AppQualityCharacteristicsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality/dashboard': {
      id: '/_app/quality/dashboard'
      path: '/quality/dashboard'
      fullPath: '/quality/dashboard'
      preLoaderRoute: typeof AppQualityDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality/inspection-orders': {
      id: '/_app/quality/inspection-orders'
      path: '/quality/inspection-orders'
      fullPath: '/quality/inspection-orders'
      preLoaderRoute: typeof AppQualityInspectionOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality/inspection-plans': {
      id: '/_app/quality/inspection-plans'
      path: '/quality/inspection-plans'
      fullPath: '/quality/inspection-plans'
      preLoaderRoute: typeof AppQualityInspectionPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality/nonconformances': {
      id: '/_app/quality/nonconformances'
      path: '/quality/nonconformances'
      fullPath: '/quality/nonconformances'
      preLoaderRoute: typeof AppQualityNonconformancesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/s/$session': {
      id: '/_app/s/$session'
      path: '/s/$session'
      fullPath: '/s/$session'
      preLoaderRoute: typeof AppSSessionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/customers': {
      id: '/_app/sales/customers'
      path: '/sales/customers'
      fullPath: '/sales/customers'
      preLoaderRoute: typeof AppSalesCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/dashboard': {
      id: '/_app/sales/dashboard'
      path: '/sales/dashboard'
      fullPath: '/sales/dashboard'
      preLoaderRoute: typeof AppSalesDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/discounts': {
      id: '/_app/sales/discounts'
      path: '/sales/discounts'
      fullPath: '/sales/discounts'
      preLoaderRoute: typeof AppSalesDiscountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/orders': {
      id: '/_app/sales/orders'
      path: '/sales/orders'
      fullPath: '/sales/orders'
      preLoaderRoute: typeof AppSalesOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/picking': {
      id: '/_app/sales/picking'
      path: '/sales/picking'
      fullPath: '/sales/picking'
      preLoaderRoute: typeof AppSalesPickingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/price-lists': {
      id: '/_app/sales/price-lists'
      path: '/sales/price-lists'
      fullPath: '/sales/price-lists'
      preLoaderRoute: typeof AppSalesPriceListsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/returns': {
      id: '/_app/sales/returns'
      path: '/sales/returns'
      fullPath: '/sales/returns'
      preLoaderRoute: typeof AppSalesReturnsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/shipments': {
      id: '/_app/sales/shipments'
      path: '/sales/shipments'
      fullPath: '/sales/shipments'
      preLoaderRoute: typeof AppSalesShipmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/agents': {
      id: '/_app/settings/agents'
      path: '/settings/agents'
      fullPath: '/settings/agents'
      preLoaderRoute: typeof AppSettingsAgentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/audit-log': {
      id: '/_app/settings/audit-log'
      path: '/settings/audit-log'
      fullPath: '/settings/audit-log'
      preLoaderRoute: typeof AppSettingsAuditLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/companies': {
      id: '/_app/settings/companies'
      path: '/settings/companies'
      fullPath: '/settings/companies'
      preLoaderRoute: typeof AppSettingsCompaniesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/numbering': {
      id: '/_app/settings/numbering'
      path: '/settings/numbering'
      fullPath: '/settings/numbering'
      preLoaderRoute: typeof AppSettingsNumberingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/adjustment-reasons': {
      id: '/_app/warehousing/adjustment-reasons'
      path: '/warehousing/adjustment-reasons'
      fullPath: '/warehousing/adjustment-reasons'
      preLoaderRoute: typeof AppWarehousingAdjustmentReasonsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/adjustments': {
      id: '/_app/warehousing/adjustments'
      path: '/warehousing/adjustments'
      fullPath: '/warehousing/adjustments'
      preLoaderRoute: typeof AppWarehousingAdjustmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/cycle-counts': {
      id: '/_app/warehousing/cycle-counts'
      path: '/warehousing/cycle-counts'
      fullPath: '/warehousing/cycle-counts'
      preLoaderRoute: typeof AppWarehousingCycleCountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/dashboard': {
      id: '/_app/warehousing/dashboard'
      path: '/warehousing/dashboard'
      fullPath: '/warehousing/dashboard'
      preLoaderRoute: typeof AppWarehousingDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/inventory': {
      id: '/_app/warehousing/inventory'
      path: '/warehousing/inventory'
      fullPath: '/warehousing/inventory'
      preLoaderRoute: typeof AppWarehousingInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/locations': {
      id: '/_app/warehousing/locations'
      path: '/warehousing/locations'
      fullPath: '/warehousing/locations'
      preLoaderRoute: typeof AppWarehousingLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/transfers': {
      id: '/_app/warehousing/transfers'
      path: '/warehousing/transfers'
      fullPath: '/warehousing/transfers'
      preLoaderRoute: typeof AppWarehousingTransfersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/warehouse-orders': {
      id: '/_app/warehousing/warehouse-orders'
      path: '/warehousing/warehouse-orders'
      fullPath: '/warehousing/warehouse-orders'
      preLoaderRoute: typeof AppWarehousingWarehouseOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehousing/warehouses': {
      id: '/_app/warehousing/warehouses'
      path: '/warehousing/warehouses'
      fullPath: '/warehousing/warehouses'
      preLoaderRoute: typeof AppWarehousingWarehousesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppProcessMapRoute: typeof AppProcessMapRoute
  AppIndexRoute: typeof AppIndexRoute
  AppModulePageRoute: typeof AppModulePageRoute
  AppEngineeringBomStructureRoute: typeof AppEngineeringBomStructureRoute
  AppEngineeringBomsRoute: typeof AppEngineeringBomsRoute
  AppEngineeringChangesRoute: typeof AppEngineeringChangesRoute
  AppEngineeringEngineeringBomsRoute: typeof AppEngineeringEngineeringBomsRoute
  AppEngineeringProductionBomsRoute: typeof AppEngineeringProductionBomsRoute
  AppManufacturingBomStructureRoute: typeof AppManufacturingBomStructureRoute
  AppManufacturingBomsRoute: typeof AppManufacturingBomsRoute
  AppManufacturingDashboardRoute: typeof AppManufacturingDashboardRoute
  AppManufacturingEngineeringBomsRoute: typeof AppManufacturingEngineeringBomsRoute
  AppManufacturingKitsRoute: typeof AppManufacturingKitsRoute
  AppManufacturingProductionOrdersRoute: typeof AppManufacturingProductionOrdersRoute
  AppManufacturingRoutingsRoute: typeof AppManufacturingRoutingsRoute
  AppManufacturingWorkCentersRoute: typeof AppManufacturingWorkCentersRoute
  AppManufacturingWorkbenchRoute: typeof AppManufacturingWorkbenchRoute
  AppMasterDataAdjustmentReasonsRoute: typeof AppMasterDataAdjustmentReasonsRoute
  AppMasterDataBomsRoute: typeof AppMasterDataBomsRoute
  AppMasterDataCharacteristicsRoute: typeof AppMasterDataCharacteristicsRoute
  AppMasterDataEngineeringBomsRoute: typeof AppMasterDataEngineeringBomsRoute
  AppMasterDataInspectionPlansRoute: typeof AppMasterDataInspectionPlansRoute
  AppMasterDataItemsRoute: typeof AppMasterDataItemsRoute
  AppMasterDataLocationsRoute: typeof AppMasterDataLocationsRoute
  AppMasterDataLotsRoute: typeof AppMasterDataLotsRoute
  AppMasterDataPartnersRoute: typeof AppMasterDataPartnersRoute
  AppMasterDataProductionBomsRoute: typeof AppMasterDataProductionBomsRoute
  AppMasterDataRoutingsRoute: typeof AppMasterDataRoutingsRoute
  AppMasterDataSerialsRoute: typeof AppMasterDataSerialsRoute
  AppMasterDataUnitsRoute: typeof AppMasterDataUnitsRoute
  AppMasterDataWarehousesRoute: typeof AppMasterDataWarehousesRoute
  AppMasterDataWorkCentersRoute: typeof AppMasterDataWorkCentersRoute
  AppPlanningDashboardRoute: typeof AppPlanningDashboardRoute
  AppPlanningMasterPlanRoute: typeof AppPlanningMasterPlanRoute
  AppPlanningMrpRoute: typeof AppPlanningMrpRoute
  AppPlanningPlannedOrdersRoute: typeof AppPlanningPlannedOrdersRoute
  AppPlanningStockCoverageRoute: typeof AppPlanningStockCoverageRoute
  AppPlanningSuggestionsRoute: typeof AppPlanningSuggestionsRoute
  AppProcurementDashboardRoute: typeof AppProcurementDashboardRoute
  AppProcurementPurchaseOrdersRoute: typeof AppProcurementPurchaseOrdersRoute
  AppProcurementPurchasePriceListsRoute: typeof AppProcurementPurchasePriceListsRoute
  AppProcurementReceiptsRoute: typeof AppProcurementReceiptsRoute
  AppProcurementReceivingRoute: typeof AppProcurementReceivingRoute
  AppProcurementSupplierReturnsRoute: typeof AppProcurementSupplierReturnsRoute
  AppProcurementSuppliersRoute: typeof AppProcurementSuppliersRoute
  AppProjectDashboardRoute: typeof AppProjectDashboardRoute
  AppProjectMyTimeRoute: typeof AppProjectMyTimeRoute
  AppProjectProgressRoute: typeof AppProjectProgressRoute
  AppProjectProjectsRoute: typeof AppProjectProjectsRoute
  AppQualityCharacteristicsRoute: typeof AppQualityCharacteristicsRoute
  AppQualityDashboardRoute: typeof AppQualityDashboardRoute
  AppQualityInspectionOrdersRoute: typeof AppQualityInspectionOrdersRoute
  AppQualityInspectionPlansRoute: typeof AppQualityInspectionPlansRoute
  AppQualityNonconformancesRoute: typeof AppQualityNonconformancesRoute
  AppSSessionRoute: typeof AppSSessionRoute
  AppSalesCustomersRoute: typeof AppSalesCustomersRoute
  AppSalesDashboardRoute: typeof AppSalesDashboardRoute
  AppSalesDiscountsRoute: typeof AppSalesDiscountsRoute
  AppSalesOrdersRoute: typeof AppSalesOrdersRoute
  AppSalesPickingRoute: typeof AppSalesPickingRoute
  AppSalesPriceListsRoute: typeof AppSalesPriceListsRoute
  AppSalesReturnsRoute: typeof AppSalesReturnsRoute
  AppSalesShipmentsRoute: typeof AppSalesShipmentsRoute
  AppSettingsAgentsRoute: typeof AppSettingsAgentsRoute
  AppSettingsAuditLogRoute: typeof AppSettingsAuditLogRoute
  AppSettingsCompaniesRoute: typeof AppSettingsCompaniesRoute
  AppSettingsNumberingRoute: typeof AppSettingsNumberingRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppWarehousingAdjustmentReasonsRoute: typeof AppWarehousingAdjustmentReasonsRoute
  AppWarehousingAdjustmentsRoute: typeof AppWarehousingAdjustmentsRoute
  AppWarehousingCycleCountsRoute: typeof AppWarehousingCycleCountsRoute
  AppWarehousingDashboardRoute: typeof AppWarehousingDashboardRoute
  AppWarehousingInventoryRoute: typeof AppWarehousingInventoryRoute
  AppWarehousingLocationsRoute: typeof AppWarehousingLocationsRoute
  AppWarehousingTransfersRoute: typeof AppWarehousingTransfersRoute
  AppWarehousingWarehouseOrdersRoute: typeof AppWarehousingWarehouseOrdersRoute
  AppWarehousingWarehousesRoute: typeof AppWarehousingWarehousesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProcessMapRoute: AppProcessMapRoute,
  AppIndexRoute: AppIndexRoute,
  AppModulePageRoute: AppModulePageRoute,
  AppEngineeringBomStructureRoute: AppEngineeringBomStructureRoute,
  AppEngineeringBomsRoute: AppEngineeringBomsRoute,
  AppEngineeringChangesRoute: AppEngineeringChangesRoute,
  AppEngineeringEngineeringBomsRoute: AppEngineeringEngineeringBomsRoute,
  AppEngineeringProductionBomsRoute: AppEngineeringProductionBomsRoute,
  AppManufacturingBomStructureRoute: AppManufacturingBomStructureRoute,
  AppManufacturingBomsRoute: AppManufacturingBomsRoute,
  AppManufacturingDashboardRoute: AppManufacturingDashboardRoute,
  AppManufacturingEngineeringBomsRoute: AppManufacturingEngineeringBomsRoute,
  AppManufacturingKitsRoute: AppManufacturingKitsRoute,
  AppManufacturingProductionOrdersRoute: AppManufacturingProductionOrdersRoute,
  AppManufacturingRoutingsRoute: AppManufacturingRoutingsRoute,
  AppManufacturingWorkCentersRoute: AppManufacturingWorkCentersRoute,
  AppManufacturingWorkbenchRoute: AppManufacturingWorkbenchRoute,
  AppMasterDataAdjustmentReasonsRoute: AppMasterDataAdjustmentReasonsRoute,
  AppMasterDataBomsRoute: AppMasterDataBomsRoute,
  AppMasterDataCharacteristicsRoute: AppMasterDataCharacteristicsRoute,
  AppMasterDataEngineeringBomsRoute: AppMasterDataEngineeringBomsRoute,
  AppMasterDataInspectionPlansRoute: AppMasterDataInspectionPlansRoute,
  AppMasterDataItemsRoute: AppMasterDataItemsRoute,
  AppMasterDataLocationsRoute: AppMasterDataLocationsRoute,
  AppMasterDataLotsRoute: AppMasterDataLotsRoute,
  AppMasterDataPartnersRoute: AppMasterDataPartnersRoute,
  AppMasterDataProductionBomsRoute: AppMasterDataProductionBomsRoute,
  AppMasterDataRoutingsRoute: AppMasterDataRoutingsRoute,
  AppMasterDataSerialsRoute: AppMasterDataSerialsRoute,
  AppMasterDataUnitsRoute: AppMasterDataUnitsRoute,
  AppMasterDataWarehousesRoute: AppMasterDataWarehousesRoute,
  AppMasterDataWorkCentersRoute: AppMasterDataWorkCentersRoute,
  AppPlanningDashboardRoute: AppPlanningDashboardRoute,
  AppPlanningMasterPlanRoute: AppPlanningMasterPlanRoute,
  AppPlanningMrpRoute: AppPlanningMrpRoute,
  AppPlanningPlannedOrdersRoute: AppPlanningPlannedOrdersRoute,
  AppPlanningStockCoverageRoute: AppPlanningStockCoverageRoute,
  AppPlanningSuggestionsRoute: AppPlanningSuggestionsRoute,
  AppProcurementDashboardRoute: AppProcurementDashboardRoute,
  AppProcurementPurchaseOrdersRoute: AppProcurementPurchaseOrdersRoute,
  AppProcurementPurchasePriceListsRoute: AppProcurementPurchasePriceListsRoute,
  AppProcurementReceiptsRoute: AppProcurementReceiptsRoute,
  AppProcurementReceivingRoute: AppProcurementReceivingRoute,
  AppProcurementSupplierReturnsRoute: AppProcurementSupplierReturnsRoute,
  AppProcurementSuppliersRoute: AppProcurementSuppliersRoute,
  AppProjectDashboardRoute: AppProjectDashboardRoute,
  AppProjectMyTimeRoute: AppProjectMyTimeRoute,
  AppProjectProgressRoute: AppProjectProgressRoute,
  AppProjectProjectsRoute: AppProjectProjectsRoute,
  AppQualityCharacteristicsRoute: AppQualityCharacteristicsRoute,
  AppQualityDashboardRoute: AppQualityDashboardRoute,
  AppQualityInspectionOrdersRoute: AppQualityInspectionOrdersRoute,
  AppQualityInspectionPlansRoute: AppQualityInspectionPlansRoute,
  AppQualityNonconformancesRoute: AppQualityNonconformancesRoute,
  AppSSessionRoute: AppSSessionRoute,
  AppSalesCustomersRoute: AppSalesCustomersRoute,
  AppSalesDashboardRoute: AppSalesDashboardRoute,
  AppSalesDiscountsRoute: AppSalesDiscountsRoute,
  AppSalesOrdersRoute: AppSalesOrdersRoute,
  AppSalesPickingRoute: AppSalesPickingRoute,
  AppSalesPriceListsRoute: AppSalesPriceListsRoute,
  AppSalesReturnsRoute: AppSalesReturnsRoute,
  AppSalesShipmentsRoute: AppSalesShipmentsRoute,
  AppSettingsAgentsRoute: AppSettingsAgentsRoute,
  AppSettingsAuditLogRoute: AppSettingsAuditLogRoute,
  AppSettingsCompaniesRoute: AppSettingsCompaniesRoute,
  AppSettingsNumberingRoute: AppSettingsNumberingRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppWarehousingAdjustmentReasonsRoute: AppWarehousingAdjustmentReasonsRoute,
  AppWarehousingAdjustmentsRoute: AppWarehousingAdjustmentsRoute,
  AppWarehousingCycleCountsRoute: AppWarehousingCycleCountsRoute,
  AppWarehousingDashboardRoute: AppWarehousingDashboardRoute,
  AppWarehousingInventoryRoute: AppWarehousingInventoryRoute,
  AppWarehousingLocationsRoute: AppWarehousingLocationsRoute,
  AppWarehousingTransfersRoute: AppWarehousingTransfersRoute,
  AppWarehousingWarehouseOrdersRoute: AppWarehousingWarehouseOrdersRoute,
  AppWarehousingWarehousesRoute: AppWarehousingWarehousesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  MfaRoute: MfaRoute,
  OnboardingRoute: OnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
